
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-search-employee",
  components: {},
})
export default class IconSearchEmployee extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
